/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Api from '@/api';
/* eslint-enable import/no-cycle */

const theState = {
    loading: false,
    applicationsLoading: false,
    processing: false,
    permissions: [],
    applications: [],
    showDialog: false,
    editPermission: {
        id: null,
        appId: null,
        appData: '',
        ssoId: '',
        createdAt: null,
        updatedAt: null,
        start_at: null,
    },
};

const getters = {
    dialogTitle(state) {
        if (state.editPermission.id === null) {
            return 'Permission hinzufügen';
        }
        return 'Permission editieren';
    },

    appId(state) {
        return state.editPermission.appId;
    },

    appData(state) {
        return state.editPermission.appData;
    },

    ssoId(state) {
        return state.editPermission.ssoId;
    },

};

const actions = {
    getApplications({ commit }) {
        commit('setApplicationsLoading', true);
        commit('setApplications', []);
        Api.application.getApplications()
            .then(({ data }) => {
                commit('setApplications', data);
            })
            .catch(() => {
                commit('setApplications', []);
            })
            .finally(() => {
                commit('setApplicationsLoading', false);
            });
    },
    getPermissions({ commit }) {
        commit('setLoading', true);
        Api.application.getPermissions()
            .then(({ data }) => {
                const permissions = data.map(app => ({
                    ...app,
                    appId: app.app_id,
                    userInfo: {
                        ...app.user_info,
                        name: `${app.user_info.first_name} ${app.user_info.last_name}`.trim(),
                    },
                    createdAt: app.created_at,
                    updatedAt: app.updated_at,
                }));
                commit('setPermissions', permissions);
            })
            .catch(() => {
                commit('setPermissions', []);
            })
            .finally(() => {
                commit('setLoading', false);
            });
    },
    addPermission({ commit, dispatch }) {
        commit('addPermission');
        dispatch('getApplications');
    },

    editPermissionById({ commit, dispatch }, permissionId) {
        commit('setLoading', true);
        commit('editPermission', permissionId);
        dispatch('getApplications');
        return new Promise((resolve, reject) => {
            Api.application.getPermissionById(permissionId)
                .then(({ data }) => {
                    const permission = {
                        ...data,
                        appId: data.app_id,
                        appData: data.appData ? JSON.stringify(data.appData, undefined, 4) : '',
                        createdAt: data.created_at,
                        updatedAt: data.updated_at,
                    };
                    commit('setEditPermission', permission);
                    resolve();
                })
                .catch(() => {
                    reject();
                    commit('closeDialog');
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        });
    },

    savePermission({ commit, dispatch, state }) {
        commit('setLoading', true);
        commit('setProcessing', true);
        return new Promise((resolve, reject) => {
            const permission = {
                app_id: state.editPermission.appId,
                data: state.editPermission.appData,
                user_id: state.editPermission.ssoId,
            };
            if (state.editPermission.id !== null) {
                Api.application.updatePermission({
                    ...permission,
                    id: state.editPermission.id,
                    start_at: state.editPermission.start_at,
                })
                    .then(() => {
                        commit('setLoading', false);
                        commit('setProcessing', false);
                        commit('closeDialog');
                        dispatch('getPermissions');
                        resolve();
                    })
                    .catch(() => {
                        commit('setLoading', false);
                        commit('setProcessing', false);
                        reject();
                    });
            } else {
                Api.application.addPermission(permission)
                    .then(() => {
                        commit('setLoading', false);
                        commit('setProcessing', false);
                        commit('closeDialog');
                        dispatch('getPermissions');
                        resolve();
                    })
                    .catch(() => {
                        commit('setLoading', false);
                        commit('setProcessing', false);
                        reject();
                    });
            }
        });
    },
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },

    setApplicationsLoading(state, applicationsLoading) {
        state.applicationsLoading = applicationsLoading;
    },

    setProcessing(state, processing) {
        state.processing = processing;
    },

    setApplications(state, applications) {
        state.applications = applications;
    },

    setPermissions(state, permissions) {
        state.permissions = permissions;
    },

    editPermission(state, permissionId) {
        Vue.set(state.editPermission, 'id', permissionId);
        state.showDialog = true;
    },

    updateSsoId(state, ssoId) {
        Vue.set(state.editPermission, 'ssoId', ssoId);
    },

    updateAppId(state, appId) {
        Vue.set(state.editPermission, 'appId', appId);
    },

    updateAppData(state, appData) {
        Vue.set(state.editPermission, 'appData', appData);
    },

    setEditPermission(state, {
        id,
        user_id,
        appId,
        appData,
        created_at,
        updated_at,
    }) {
        Vue.set(state, 'editPermission', {
            id,
            ssoId: user_id,
            appId,
            appData,
            createdAt: created_at,
            updatedAt: updated_at,
        });
    },

    closeDialog(state) {
        state.showDialog = false;
        Vue.set(state, 'editPermission', {
            id: null,
            ssoId: '',
            appId: null,
            appData: '',
            createdAt: null,
            updatedAt: null,
        });
    },

    addPermission(state) {
        Vue.set(state.editPermission, 'id', null);
        state.showDialog = true;
    },
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
